import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable()
export class HttpConfigService {
    public readonly apiServerUrl: string = environment.apiServerUrl;
}
